import React from "react"
import {Link} from 'gatsby'
import projects from "../data/projects"
import EntryProject from "../components/projectentry"

function createProjects(service) {
  return (
    <EntryProject
      key={service.id}
      title={service.title}
      image={service.image}
      githuburl={service.githuburl}
      linkedinurl={service.linkedinurl}
    />
  );
}

const Projects = () => (
  <div className="row" style={{color:"white"}}>
    <div className="services">
      <h2 className="align-middle" style={{color:"#fff"}}><b>Project Showcase</b></h2>
      <p className="align-middle" style={{color:"#dfdfdf"}}>Here are some of the Web Development & Wordpress Projects that I had made.</p>
      <ul className="align-middle" style={{marginLeft:"0px"}}>
      <li className="list-inline-item"><Link className="skills-button" to="/projects">View All Projects</Link></li>
      </ul>
      <div className="row myservices-container animated fadeInLeft">
        {projects.slice(0, 3).map(createProjects)}
      </div>
    </div>
  </div>
)

export default Projects
